<template>
	<div class="row align-items-center justify-content-center">
		<div class="col-3 d-lg-block d-none mx-auto">
			<b-img @click="redirectTo('https://arxiv.org/abs/2401.12761')" style="cursor: pointer;" class="m-3 w-75" src="/imgs/paper-image-arxiv.png" center thumbnail fluid alt="paper overview"></b-img>
		</div>
		<div class="col-lg-9 col-12 mt-5 justify-content-center align-items-center">
			<h3 class="text-center">MUSES: The Multi-Sensor Semantic Perception Dataset for Driving under
				Uncertainty </h3>
			<h6 class="text-center">Tim Brödermann, David Bruggemann, Christos Sakaridis, Kevin Ta, Odysseas
				Liagouris,</h6>
			<h6 class="text-center">Jason Corkill, Luc Van Gool</h6>
			<h6 class="text-center">In Proceedings of the European Conference on Computer Vision (ECCV), 2024</h6>
			<!-- <p class="text-center"><strong>arXiv 2024</strong></p> -->
			<p class="text-center">
				<!-- <a href="">Paper</a> &middot; <a href="">BibTeX</a> &middot; <a href="">arXiv</a> &middot; <a href="">Supplementary Material</a> -->

        <a href="/pub_files/muses/MUSES.pdf" target="_blank">Paper</a>
        &middot;
        <a href="/pub_files/muses/MUSES-supp.pdf" target="_blank">Supplement</a>
        &middot;
        <a href="https://github.com/timbroed/MUSES" target="_blank">SDK</a>
        &middot;
        <a href="https://arxiv.org/abs/2401.12761">arXiv</a>
        &middot;
        <a href="/pub_files/muses/muses_arxiv2024.bib">BibTeX</a>
			</p>
		</div>
	</div>
</template>
<script>

export default {
  name: "CiteComponent.vue",
  components: { },
  methods: {
    redirectTo(link) {
      window.location.href = link
  }}
};
</script>
